<template>
  <div class="padded">
    <span
      v-if="!hideBackLink"
      class="backLink"
      @click="goBack()"
    >
      {{ linkTitle }}
    </span>
    <h1 class="title">{{ title }}</h1>
    <h2
      v-if="isDescriptionVisible"
      v-dompurify-html="description"
      class="sub-title"
    />
    <template v-if="showSubItems">
      <div
        v-if="stepsTitle"
        class="stepsTitle"
      >
        {{ stepsTitle }}
      </div>
      <div
        v-if="isStepsVisible"
        v-dompurify-html="steps"
        :class="['steps', { 'multi-column': columns > 1 }]"
      />
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      columns: {
        type: Number,
        default: 1,
        required: false
      },
      linkTitle: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        default: '',
        required: false
      },
      steps: {
        type: String,
        default: '',
        required: false
      },
      stepsTitle: {
        type: String,
        default: '',
        required: false
      },
      hideBackLink: {
        type: Boolean,
        default: false
      },
      showSubItems: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      isDescriptionVisible () {
        return this.description.length > 0
      },
      isStepsVisible () {
        return this.steps.length > 0
      }
    },
    methods: {
      goBack () {
       this.$emit('goBack')
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .padded {
    padding: 0 23px;

    @include bp-mf-tablet {
      padding: 0;
    }
  }

  .backLink {
    display: block;
    margin-top: 0;
    color: $blue-medium;
    font-size: em(14);
    line-height: 16px;
    text-decoration: none;
    cursor: pointer;
    margin-bottom: 16px;

    &:before {
      @include icon-font-thin();
      content: $icon-arrow-left-thin;
      font-size: em(11);
      margin-right: 5px;
    }
  }

  .title {
    font-size: em(32);
    line-height: 38px;
    font-weight: 200;
    margin: 0 0 15px;

    @include bp-mf-tablet {
      font-size: em(40);
      line-height: 47px;
      margin: 12px 0 12px;
    }
  }

  .sub-title {
    font-size: em(18);
    font-weight: 200;
    line-height: 24px;
    margin-bottom: 18px;
    margin-top: 0;

    @include bp-mf-tablet {
      font-size: em(20);
      line-height: 32px;
    }

    ::v-deep a {
      color: $blue-medium;
      text-decoration: underline;

      &:visited {
        color: $blue-medium;
        text-decoration: underline;
      }
    }
  }

  .stepsTitle {
    color: $grey-default;
    font-size: em(16);
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 17px;
  }

  .steps {
    @include bp-mf-tablet {
      margin-bottom: 32px;
    }

    &.multi-column {
      margin-bottom: 32px;

      @include bp-mf-tablet {
        margin-bottom: 39px;
      }

      ::v-deep ul {

        @include bp-mf-tablet {
          columns: 2;
          margin: 0 0 0 4px;
        }

        li {

          @include bp-mf-tablet {
            break-inside: avoid-column;
            page-break-inside:avoid;
          }
        }
      }
    }

    @include bp-mf-tablet {
      margin-bottom: 32px;
    }

    ::v-deep ul {
      list-style: none;
      position: relative;
      margin-bottom: 24px;

      @include bp-mf-tablet {
        margin: 27px 0 0 12px;
      }
    }

    ::v-deep li {
      position: relative;
      margin-bottom: 12px;
      color: $grey-default;
      font-size: em(14);
      letter-spacing: 0;
      line-height: 20px;
      padding-left: 20px;

      @include bp-mf-tablet {
        font-size: em(16);
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 8px;
        height: 8px;
        left: 0;
        background-color: $green-base;
        border-radius: 50%;
        top: 5px;
      }
    }

    ::v-deep a {
      color: $blue-medium;
      text-decoration: underline;

      &:visited {
        color: $blue-medium;
        text-decoration: underline;
      }
    }
  }

</style>
